import { createFileRoute } from "@tanstack/react-router";
import { TeacherSubmissions } from "@/projects/teacher/pages/SubmissionsPage";

export const Route = createFileRoute("/teacher/submissions")({
  head: () => ({ meta: [{ title: "My Assignments — Teacher" }] }),
  component: TeacherSubmissions,
});
